<template>
  <div>
    <el-row>
      <el-col>
        <div style="display: flex; position: relative; float: right">
          <div class="box mr-5">
            <years-component ref="yearC" @change="handler_year" v-model="year">
            </years-component>
            <!-- <years-component :initial="year"></years-component>   *:filterables="true" @filter-search="search = $event"* -->
          </div>

          <EmployeeSelector
            :placeholder="'Colaborador'"
            @selection-change="updateSelectedEmployee"
            @list-employee="employeList = $event"
            class="mr-5"
          />

          <!-- <DirectionSelector
            v-model="directionId"
            @selection-change="handleChangeDirection" /> -->
          <DepartmentSelector
            @selection-change="handleChangeDepartment"
            @onDirectionChange="handleChangeDirection"
            :onlyDepartment="false"
            :directionIdProp="directionId"
          />
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <el-card :body-style="{ padding: '1px' }" shadow="always">
          <RabbeyTable3
            :border="true"
            :stripe="true"
            ref="table"
            v-loading="loading"
            :data="personsData"
            :columns="columnsPersons"
            :height="650"
            fit
          >
          </RabbeyTable3>
        </el-card>
      </el-col>
    </el-row>

    <div id="detail">
      <el-drawer
        title="Tareas del mes"
        :visible.sync="drawer"
        :before-close="handleClose"
        size="70%"
      >
        <el-container>
          <el-main>
            <el-row>
              <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                <table style="font-size: 24px" id="table-card">
                  <tr style="font-size: 24px">
                    <table style="font-size: 24px">
                      <tr style="font-size: 24px">
                        <td>Responsable:</td>
                      </tr>
                      <tr style="font-size: 24px">
                        <td>
                          <img
                            :src="image ? image : perfilImage"
                            alt="logo_foto"
                          />
                          <br />
                          <strong> {{ Responsable }}</strong>
                        </td>
                      </tr>
                    </table>
                  </tr>
                </table>
              </el-col>

              <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                <table style="font-size: 25px" id="table-card">
                  <tr>
                    <td>
                      <label>Mes:</label>
                      <strong> {{ month }}</strong>
                    </td>
                  </tr>
                </table>
              </el-col>
              <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                <el-row style="padding: 5px">
                  <table style="font-size: 25px" id="table-card">
                    <tr style="font-size: 20px">
                      <td>Efectividad:</td>
                      <td>
                        <!-- <el-tag :type="GetTagType" style="font-size: 25px">
                          {{ Efective }}
                        </el-tag> -->
                        <el-tag
                          style="font-size: 25px"
                          type="danger"
                          v-if="Efective < 80"
                          >{{ `${Efective}` + `.00` }} %</el-tag
                        >

                        <el-tag
                          style="font-size: 25px"
                          type="warning"
                          v-if="Efective >= 80 && Efective <= 99"
                          >{{ `${Efective}` + `.00` }} %</el-tag
                        >

                        <el-tag
                          style="font-size: 25px"
                          type="success"
                          v-if="Efective > 99"
                          >{{ `${Efective}` + `.00` }} %</el-tag
                        >
                      </td>
                    </tr>
                    <tr style="font-size: 20px">
                      <td>Cerrdad a tiempo:</td>
                      <td>
                        <strong> {{ onTime }}</strong>
                      </td>
                    </tr>
                    <tr style="font-size: 20px">
                      <td>Cerrada Tarde:</td>
                      <td>
                        <strong>{{ onDues }}</strong>
                      </td>
                    </tr>
                    <!-- <tr style="font-size: 20px">
                      <td>Retrasada:</td>
                      <td>
                        <strong>{{ onRetrass }}</strong>
                      </td>
                    </tr>
                    <tr style="font-size: 20px">
                      <td>Pendiente:</td>
                      <td>
                        <strong> {{ onPedding }}</strong>
                      </td>
                    </tr> -->
                    <tr style="font-size: 20px">
                      <td>Total:</td>
                      <td>
                        <strong> {{ totalTarea }}</strong>
                      </td>
                    </tr>
                  </table>
                </el-row>
              </el-col>
            </el-row>
            <CloseTasksChart ref="detailChart" :DetailParams="DetailParams" />
            <rabbey-toolbox
              filterables
              @filter-search="detailSearch = $event"
            />

            <el-row>
              <el-col>
                <RabbeyTable3
                  :search="detailSearch"
                  :data="tasks"
                  v-loading="loadingTask"
                  :columns="TaskColumns"
                  :height="600"
                />
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import YearsComponent from "../../../../components/Global_System/YearsComponent.vue";
import { PersonColumns, TaskColumns } from "./DashBoardColumns";
import EmployeeSelector from "@/components/Company/EmployeeSelector.vue";
// import DirectionSelector from "@/components/Company/DirectionSelector.vue";
import DepartmentSelector from "@/components/Company/DepartmentSelector.vue";
import CloseTasksChart from "@/views/Charts/CloseTasksChart.vue";

// import HyperLinkSeller from "@/components/functionals/HyperLinkSeller.vue";
// import Hypper from "@/components/functionals/HyperLinkDashboard.vue";
export default {
  name: "DashBoardCmi",
  components: {
    YearsComponent,
    // DirectionSelector,
    EmployeeSelector,
    RabbeyTable3,
    DepartmentSelector,
    CloseTasksChart
  },
  data() {
    return {
      //Se introdujo la propiedad image como nulo para el icono de los empleados de cada tarea asignada

      image: null,
      detailSearch: "",
      search: "",
      Responsable: "",
      EmployeeId: 0,
      month: "",
      TotalCumplida: "",
      TotalFallida: "",
      Total: "",
      percent: 100,
      onDues: 0,
      onTime: 0,
      Efective: 0,
      totalTarea: 0,

      directionId: 0,
      departmentId: 0,
      year: new Date().getFullYear(),
      loading: true,
      loadingTask: true,
      columnsPerson: [],
      data: [],
      tasks: [],
      drawer: false,
      cls: PersonColumns,
      TaskColumns,
      DetailParams: {
        Month: 0,
        Year: 0,
        EmployeeId: 0,
        chartData: []
      }
    };
  },
  methods: {
    showmodal(column) {
      this.image = null;
      this.month = column.column;
      this.DetailParams = {
        EmployeeId: column.row.Employeeid,
        Year: this.year,
        Month: column.mes
      };
      this.Responsable = column.row.PersonName;
      this.loadingTask = true;
      this.$http
        .get("/api/CMI/Task/GetCustomTaks", {
          params: {
            employeeid: column.row.Employeeid,
            month: column.mes,
            year: this.year,
            companyID: this.currentCompany,
            option: "gantt"
          }
        })
        .then(({ data }) => {
          this.loadingTask = false;
          this.onTime = data.CerradasAtiempo;
          this.onDues = data.CerradasTarde;
          this.Efective = data.Effectividad;
          this.totalTarea = data.TotalTarea;
          this.tasks = data.TareasPorPersonas;
          this.image = data.TareasPorPersonas[0].UserUrlImage;
          this.$refs.detailChart.getChartData();
        });
      this.drawer = true;
    },
    GetTagType() {
      if (this.percent.replace("%", "") <= 70) {
        return "danger";
      } else if (this.percent.replace("%", "") == 100) {
        return "danger";
      } else if (
        this.percent.replace("%", "") >= 71 &&
        this.percent.replace("%", "") <= 89
      ) {
        return "warning";
      }
      return "warning";
    },
    handleClose() {
      this.$refs.detailChart.bar.series[0].data = [];
      this.$refs.detailChart.loading = true;
      this.drawer = false;
    },
    getData() {
      this.cure;
      this.loading = true;
      let params = {
        year: this.year,
        CompanySeleted: this.currentCompany,
        responsableDirec: this.directionId == 0 ? null : this.directionId,
        responsableEmpl: this.EmployeeId == 0 ? null : this.EmployeeId,
        responsableDepartment:
          this.departmentId == 0 ? null : this.departmentId,
        option: "gantt"
      };
      this.$http
        .get("/api/CMI/Objetives/Dashboard", { params })
        .then(({ data }) => {
          //cuando se carga la data la imagen pasa a ser null para limpiar la imagen cada ves que carge una nueva

          this.data = data;
          this.image = false;
          this.loading = false;
        })
        .catch(() => {})
        .finally(() => (this.loading = false));
    },
    handleChangeDirection(directionId) {
      this.directionId = directionId;
      this.departmentId = null;
      this.getData();
    },
    updateSelectedEmployee(employee) {
      this.EmployeeId = employee;
      this.getData();
    },
    handler_year(_year) {
      this.year = _year;
      this.getData();
    },
    handleChangeDepartment(DepartmentID) {
      this.departmentId = DepartmentID;
      this.getData();
    }
  },
  computed: {
    //utilice el mapState para el icono por default de la imagen de los empleados

    ...mapState({
      user: (state) => state.user.user,
      perfilImage: (state) => state.user.imageUrl
    }),

    // Efective() {
    //   let ontime = this.tasks.filter(
    //     (c) => c.Status !== "Abierta Retrasada" && c.Status !== "Pendiente"
    //   ).length;
    //   return ((ontime / this.tasks.length) * 100).toFixed(0) + "%";
    // },
    // onTime() {
    //   return this.tasks.Tareas.filter((c) => c.Status === "Cerrada a Tiempo").length;
    // },
    // onRetrass() {
    //   return this.tasks.filter((c) => c.Status === "Abierta Retrasada").length;
    // },
    // onDues() {
    //   return this.tasks.filter((c) => c.Status === "Cerrada Retrasada").length;
    // },
    // onPedding() {
    //   return this.tasks.filter((c) => c.Status === "Pendiente").length;
    // },
    personsData() {
      if (this.data == null) {
        return [];
      }
      return this.data.PersonsProductivites;
    },

    columnsPersons() {
      let columns = this.cls.map((column) => {
        if (column["cellAtrrs"] !== undefined) {
          column["cellAtrrs"] = {
            ...column["cellAtrrs"],
            OpenSelection: this.showmodal
          };

          return {
            ...column
            // formatter: HyperLinkSeller
            //formatter: Hypper
          };
        }

        return column;
      });

      return columns;
    }
  },
  mounted() {
    this.$refs.yearC.Year = this.year;

    this.getData();
  }
};
</script>

<style scoped>
img {
  width: 10%;
  height: 4%;
  border-radius: 50%;
}
</style>
